module.exports = __webpack_public_path__ + "img/1491389895.7ae66457.jpg";